export default {
  FIREBASE_PROJECT_ID: 'assetron-production-project',
  FIREBASE_STORAGE_BUCKET: 'assetron-production-project.firebasestorage.app',
};
